import { render, staticRenderFns } from "./ServiceRadioFormPart.nl.vue?vue&type=template&id=0f5f83d3"
import script from "./ServiceRadioFormPart.nl.vue?vue&type=script&lang=js"
export * from "./ServiceRadioFormPart.nl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports